/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlHyperlink } from './ControlHyperlink';
import {
    ControlHyperlinkFromJSON,
    ControlHyperlinkFromJSONTyped,
    ControlHyperlinkToJSON,
} from './ControlHyperlink';
import type { ControlZeroDayAlertStats } from './ControlZeroDayAlertStats';
import {
    ControlZeroDayAlertStatsFromJSON,
    ControlZeroDayAlertStatsFromJSONTyped,
    ControlZeroDayAlertStatsToJSON,
} from './ControlZeroDayAlertStats';

/**
 * 
 * @export
 * @interface ControlAppSchemasAdminGetZeroDayAlertResponse
 */
export interface ControlAppSchemasAdminGetZeroDayAlertResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    cve?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    short_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    long_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    how_to_resolve: string;
    /**
     * 
     * @type {Array<ControlHyperlink>}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    references: Array<ControlHyperlink>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    escalated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    published?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    version_message?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    first_detected_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    created_date: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    updated_date: string;
    /**
     * 
     * @type {ControlZeroDayAlertStats}
     * @memberof ControlAppSchemasAdminGetZeroDayAlertResponse
     */
    stats: ControlZeroDayAlertStats;
}

/**
 * Check if a given object implements the ControlAppSchemasAdminGetZeroDayAlertResponse interface.
 */
export function instanceOfControlAppSchemasAdminGetZeroDayAlertResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "vendor_name" in value;
    isInstance = isInstance && "short_risk_description" in value;
    isInstance = isInstance && "long_risk_description" in value;
    isInstance = isInstance && "how_to_resolve" in value;
    isInstance = isInstance && "references" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "created_date" in value;
    isInstance = isInstance && "updated_date" in value;
    isInstance = isInstance && "stats" in value;

    return isInstance;
}

export function ControlAppSchemasAdminGetZeroDayAlertResponseFromJSON(json: any): ControlAppSchemasAdminGetZeroDayAlertResponse {
    return ControlAppSchemasAdminGetZeroDayAlertResponseFromJSONTyped(json, false);
}

export function ControlAppSchemasAdminGetZeroDayAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAppSchemasAdminGetZeroDayAlertResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zero_day_alert_id': json['zero_day_alert_id'],
        'version': json['version'],
        'name': json['name'],
        'title': json['title'],
        'vendor_name': json['vendor_name'],
        'cve': !exists(json, 'cve') ? undefined : json['cve'],
        'short_risk_description': json['short_risk_description'],
        'long_risk_description': json['long_risk_description'],
        'how_to_resolve': json['how_to_resolve'],
        'references': ((json['references'] as Array<any>).map(ControlHyperlinkFromJSON)),
        'active': json['active'],
        'escalated': !exists(json, 'escalated') ? undefined : json['escalated'],
        'published': !exists(json, 'published') ? undefined : json['published'],
        'version_message': !exists(json, 'version_message') ? undefined : json['version_message'],
        'first_detected_date': !exists(json, 'first_detected_date') ? undefined : json['first_detected_date'],
        'created_date': json['created_date'],
        'updated_date': json['updated_date'],
        'stats': ControlZeroDayAlertStatsFromJSON(json['stats']),
    };
}

export function ControlAppSchemasAdminGetZeroDayAlertResponseToJSON(value?: ControlAppSchemasAdminGetZeroDayAlertResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zero_day_alert_id': value.zero_day_alert_id,
        'version': value.version,
        'name': value.name,
        'title': value.title,
        'vendor_name': value.vendor_name,
        'cve': value.cve,
        'short_risk_description': value.short_risk_description,
        'long_risk_description': value.long_risk_description,
        'how_to_resolve': value.how_to_resolve,
        'references': ((value.references as Array<any>).map(ControlHyperlinkToJSON)),
        'active': value.active,
        'escalated': value.escalated,
        'published': value.published,
        'version_message': value.version_message,
        'first_detected_date': value.first_detected_date,
        'created_date': value.created_date,
        'updated_date': value.updated_date,
        'stats': ControlZeroDayAlertStatsToJSON(value.stats),
    };
}

